module.exports = __webpack_public_path__ + "static/media/m-bubbles.7b222a17.png";